/**
 * Gate de preço do módulo Produção (regra da gestora): valores monetários
 * só aparecem para quem tem `preco:view` (ou Master). Centralizado aqui
 * para as telas do módulo aplicarem a MESMA regra (Dbr, Detalhe do Pedido,
 * BOM do ambiente…).
 *
 * O gate do frontend é UX — a proteção real é o serializer do backend
 * omitir os campos de custo sem a permissão (auditoria: "detalhe por
 * permissão sem filtrar o serializer é cosmético").
 */
import { useAuth } from "../../../context/AuthContext";

export const DICA_SEM_PRECO = "valores requerem permissão de preços";

export function usePodeVerPrecos() {
  const { hasAllPermissions, isMaster } = useAuth();
  return hasAllPermissions(["preco:view"]) || isMaster;
}
